import request from '@/utils/request'

export const getdatalist = (params: any) =>
  request({
    url: '/user/getUserList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getSideWaylist = (params: any) =>
  request({
    url: '/users/getSideWayUserInfo',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getorginizlist = (params: any) =>
  request({
    url: '/users/getOrganInfoByID',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const adduser = (params: any) =>
  request({
    url: '/user/addUser',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const getuserinfodata = (params: any) =>
  request({
    url: '/user/getUserByID',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const changestate = (params: any) =>
  request({
    url: '/user/updateUser',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getorglist = (params: any) =>
  request({
    url: '/organization/getOrganList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })

